





























































import {
	Component,
	Vue,
	Watch
} from "vue-property-decorator";
import {
	Button,
	Field,
	Popup,
	Picker,
	Cell,
	CellGroup,
	DatetimePicker,
	Toast
} from "vant";
import {
	formatDate
} from "@/utils/date";
import CustomSelect from "./components/CustomSelect.vue";
import { PhoneNum,Englist } from "@/utils/verify";

@Component({
	name: "InstitutionalOpen",
	components: {
		[Button.name]: Button,
		[Field.name]: Field,
		[Popup.name]: Popup,
		[Picker.name]: Picker,
		[Cell.name]: Cell,
		[CellGroup.name]: CellGroup,
		customSelect: CustomSelect,
		[DatetimePicker.name]: DatetimePicker
	}
})
export default class InstitutionalOpen extends Vue {
	institutionalform = {
		real_name: "",
		english_name: "",
		birth: "",
		register_address: "",
		id_card: "",
		company_address: "",
		company_phone: "",
		email: "",
		executive_director: ""
	}
	showbirthPicker = false;
	currentDate = new Date();
	placecolumns: any = [];
	typefinacl: any = sessionStorage.getItem("type");
	mounted() {

		(this as any).getenums();

	}

	activated(){
		const userInfo = (this as any).$localstorage.get("userInfo") || {};
		(this as any).institutionalform.email = userInfo.email;
	}

	handlebirth() {
		this.currentDate = this.institutionalform.birth == "" ? new Date() : new Date(this.institutionalform.birth);
	}

	handleConfirmbirth(date) {
		(this as any).institutionalform.birth = formatDate(date, "yyyy-MM-dd");
		(this as any).showbirthPicker = false;
	}
	getenums(){
		(this as any).$apis.getEnum({key:'registerPlace'}).then(res =>{
			const data = res.map(item => {
			  return {
			    text: item.value_display,
			    value: item.value
			  }
			});
			(this as any).placecolumns = data;
			(this as any).placecolumns.find(
			  item => (this as any).institutionalform.register_address = item.value
			);
		})
	}
	get minDate() {
		let date = new Date();
		let y = date.getFullYear() - 200
		return new Date(y + '/' + '1/1');
	}

	get maxDate() {
		let date = new Date();
		let y = date.getFullYear();
		let m = date.getMonth() + 1;
		let d = date.getDate();

		return new Date(y + '/' + m + '/' + d);
	}

	get isSubmitDisabled() {
		const formDisabled = !(this as any).institutionalform.birth || !(this as any).institutionalform.register_address ||!(this as any).institutionalform.id_card || !(this as any).institutionalform.company_address ||!(this as any).institutionalform.company_phone || !(this as any).institutionalform.email ||!(this as any).institutionalform.executive_director;
		return formDisabled
	}

	handleChange(e) {
		(this as any).institutionalform.register_address = e.value
	}

	handEmailBind() {
		(this as any).$router.push({
			path: "/email-bind"
		});
	}
	handleSavePersonalInfo() {
		if(!(this as any).institutionalform.real_name && !(this as any).institutionalform.english_name){
			return (this as any).$toast("請輸入機構名稱")
		}else if(PhoneNum((this as any).institutionalform.company_phone) === false){
			return (this as any).$toast("機構電話輸入有誤")
		}else {
			(this as any).$apis.saveCompanyInfo({...(this as any).institutionalform}).then(res =>{
				(this as any).$router.push({
					name:"MServiceOpening",
					query:{
						open_method:2
					}
				})
			})
		}
	}

}
